module.exports = __webpack_public_path__ + "static/media/nlu.bbace2f5.JPG";